import { render, staticRenderFns } from "./EditRtmpConfigForm.vue?vue&type=template&id=56d2ac74&scoped=true&"
import script from "./EditRtmpConfigForm.vue?vue&type=script&lang=js&"
export * from "./EditRtmpConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./EditRtmpConfigForm.vue?vue&type=style&index=0&id=56d2ac74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2ac74",
  null
  
)

export default component.exports